<template>
  <div v-if="content" class="view-content container mt-5">
    <v-card class="pa-5" shaped>
      <div class="content">
        <h3 class="headline content-title">{{ content.title }}</h3>
        <div class="author grey--text">{{ content.author }}</div>
        <p class="content mt-4">{{ content.content }}</p>
        <v-btn text outlined color="pink">
          <span class="black--text">좋아요 {{ content.likes }}</span>
          <v-icon small color="pink">mdi-heart</v-icon>
        </v-btn>
        <v-btn text outlined color="green" class="ml-2">
          <span class="black--text">링크 3줄쓰기</span>
          <v-icon small color="green">mdi-link</v-icon>
        </v-btn>
      </div>
    </v-card>
    <v-card class="pa-5 mt-5">
      <div class="comments">
        <h3 class="headline content-title">댓글</h3>
      </div>
      <v-list>
        <v-list-item-group>
          <v-list-item v-for="comment in comments" :key="comment.id">
            <v-list-item-icon>
              <v-icon small>mdi-comment-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ comment.title }}</v-list-item-title>
              <p class="mt-2">{{ comment.content }}</p>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-btn text outlined color="blue">
        <v-icon small>mdi-plus</v-icon>
        댓글 쓰기
      </v-btn>
    </v-card>
  </div>
  <div v-else>
    <Progress />
  </div>
</template>

<script>
import db from '@/firebase/init'
import Progress from '@/components/layouts/Progress'

export default {
  name: 'viewContent',
  components: { Progress },
  data() {
    return {
      content: null,
      comments: [
        { id: 1, title: '기초의학', content: '대한민국의 주권은 국민에게 있고, 모든 권력은 국민으로부터 나온다. 헌법재판소의 장은 국회의 동의를 얻어 재판관중에서 대통령이 임명한다.' },
        { id: 2, title: '종합평가', content: '국회의 회의는 공개한다. 다만, 출석의원 과반수의 찬성이 있거나 의장이 국가의 안전보장을 위하여 필요하다고 인정할 때에는 공개하지 아니할 수 있다.' },
        { id: 3, title: '문제풀이', content: '근로조건의 기준은 인간의 존엄성을 보장하도록 법률로 정한다. 탄핵결정은 공직으로부터 파면함에 그친다. 그러나, 이에 의하여 민사상이나 형사상의 책임이 면제되지는 아니한다.' }
      ]
    }
  },
  created() {
    let ref = db.collection('contents')
    ref.doc(this.$route.params.id).get()
      .then(content => {
        this.content = content.data()
      })
  }
}
</script>

<style>
.view-content .content {
  font-size: 1em;
}

.view-content .content-title {
  display: inline-block;
}

.view-content .author {
  font-size: 0.8em;
}
</style>
